import { SvgIcon, SvgIconProps } from "@mui/material";

export const LibraryIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M20 16.235V18a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-1.767"
      />
      <rect
        width="18"
        height="14"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        rx="3"
        transform="matrix(-1 0 0 1 21 3)"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M14 10h-4M12 12V8"
      />
    </svg>
  </SvgIcon>
);
